var scope_0 = require('/home/runner/work/commerce-frontend-core/commerce-frontend-core/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/192280ed520e57a2912291d3d4df3dfa.js').default;
var scope_1 = require('/home/runner/work/commerce-frontend-core/commerce-frontend-core/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    